import {Action, getModule, Module, Mutation, VuexModule} from "vuex-module-decorators";
import {PickingListReTransportState} from "@/interfaces/state";
import store from "@/store";
import {PaginationMeta} from "@/interfaces/common";
import {PickingListReTransportParams} from "@/modules/pickinglistretransport/params";
import {IdMapper} from "@/interfaces/state/base";
import {PickingListReTransport} from "@/interfaces/entity/pickinglistretransport";
import {union} from 'lodash';
import {Lading} from "@/interfaces/entity";
import {LadingStore} from "@/modules/ladings/store";
import {
	deletePickingListReTransport,
	listBillLadingByPickingListReTransportId,
	listPickingListReTransport,
	singlePickingListReTransport
} from "@/modules/pickinglistretransport/services";

@Module({dynamic: true, name: "pickingListReTransport", store})
class PickingListReTransportModule extends VuexModule implements PickingListReTransportState {
	data: IdMapper<PickingListReTransport> = {};
	ids: number[] = [];
	meta: PaginationMeta = new PaginationMeta();
	params: any = new PickingListReTransportParams();

	@Mutation
	private MAP_PICKING_LIST_RE_TRANSPORT(payload: any) {
		const idMapper: IdMapper<PickingListReTransport> = {};
		this.meta = payload.meta;
		this.ids = payload.datas.map((pickingList: PickingListReTransport) => {
			idMapper[pickingList.id] = pickingList;
			return pickingList.id;
		});
		this.data = idMapper;
	}

	@Mutation ADD_PICKING_LIST_RE_TRANSPORT(payload: PickingListReTransport) {
		if (!payload) return;
		this.ids = union(this.ids, [payload.id]);
		this.data[payload.id] = {
			...this.data[payload.id] || {},
			...payload
		};
	}

	@Mutation
	private REMOVE_PICKING_LIST_RE_TRANSPORT(payload: number) {
		this.ids.splice(this.ids.indexOf(payload), 1);
	}

	@Mutation
	private UPDATE_PICKING_LIST_RE_TRANSPORT_PARAMS(payload: any) {
		this.params = payload;
	}

	@Mutation
	private SET_BILL_LADINGS_INTO_PICKING_LIST_RE_TRANSPORT({ id, billLadings }) {
		if (this.data[id]) {
			this.data[id] = { ...this.data[id], billLadings };
		}
		billLadings.forEach((billLading: Lading) => LadingStore.addLading(billLading));
	}

	@Mutation
	private CLEAR_PICKING_LIST_RETRANSPORTS() {
		this.ids = [];
		this.data = {};
	}

	@Action({ rawError: true })
	public updatePickingListReTransportParams(payload: any) {
		this.UPDATE_PICKING_LIST_RE_TRANSPORT_PARAMS(payload);
	}

	@Action( { rawError: true})
	public async listPickingListReTransport(payload: any) {
		const { data } = await listPickingListReTransport(payload);
		this.MAP_PICKING_LIST_RE_TRANSPORT(data);
	}

	@Action( { rawError: true})
	public async singlePickingListReTransport(payload: any) {
		const { data } = await singlePickingListReTransport(payload);
		this.ADD_PICKING_LIST_RE_TRANSPORT(data.data);
	}

	@Action( {rawError: true})
	public async listBillLadingByPickingListReTransport(payload: any) {
		const { data } = await listBillLadingByPickingListReTransportId(payload);
		this.SET_BILL_LADINGS_INTO_PICKING_LIST_RE_TRANSPORT({id: payload, billLadings: data.datas});
	}

	@Action( { rawError: true})
	public addPickingListReTransport(payload: any) {
		this.ADD_PICKING_LIST_RE_TRANSPORT(payload);
	}

	@Action({ rawError: true })
	public clearPickingListReTransport() {
		this.CLEAR_PICKING_LIST_RETRANSPORTS();
	}

	@Action({ rawError: true })
	public async deletePickingListReTransport(payload: number) {
		await deletePickingListReTransport(payload);
		this.REMOVE_PICKING_LIST_RE_TRANSPORT(payload);
	}
}

export const PickingListReTransportStore = getModule(PickingListReTransportModule);
